import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { CLINIC } from "../data/site";
import { scrollToId } from "../lib/scroll";

const LINKS = [
    { label: "Perché noi", href: "#perche" },
    { label: "Come funziona", href: "#come-funziona" },
    { label: "Prezzi", href: "#prezzi" },
    { label: "Tecnologia", href: "#tecnologia" },
    { label: "Galleria", href: "#galleria" },
    { label: "FAQ", href: "#faq" },
];

export const Navbar = () => {
    const [open, setOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 40);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const go = (e, href) => {
        e.preventDefault();
        setOpen(false);
        scrollToId(href);
    };

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-500 border-b ${
                scrolled
                    ? "bg-black/60 backdrop-blur-xl border-white/10"
                    : "bg-transparent border-transparent"
            }`}
        >
            <nav className="max-w-7xl mx-auto flex items-center justify-between px-5 sm:px-8 h-16 sm:h-[72px]">
                <a
                    href="#top"
                    data-testid="nav-logo-link"
                    onClick={(e) => go(e, "#top")}
                    className="font-display text-lg sm:text-xl text-white tracking-tight"
                >
                    Klinica Dentale <span className="italic text-gold">L'Unite</span>
                </a>

                <div className="hidden lg:flex items-center gap-8">
                    {LINKS.map((link) => (
                        <a
                            key={link.href}
                            href={link.href}
                            data-testid={`nav-link-${link.href.slice(1)}`}
                            onClick={(e) => go(e, link.href)}
                            className="text-xs uppercase tracking-[0.18em] text-white/60 hover:text-white transition-colors duration-300"
                        >
                            {link.label}
                        </a>
                    ))}
                    <a
                        href="#contatti"
                        data-testid="nav-cta-contatti"
                        onClick={(e) => go(e, "#contatti")}
                        className="text-xs uppercase tracking-[0.18em] px-5 py-2.5 rounded-full border border-gold/60 text-gold hover:bg-gold hover:text-black transition-colors duration-300"
                    >
                        Contattaci
                    </a>
                </div>

                <button
                    data-testid="nav-mobile-menu-button"
                    onClick={() => setOpen(!open)}
                    className="lg:hidden text-white p-2"
                    aria-label="Menu"
                >
                    {open ? <X size={22} /> : <Menu size={22} />}
                </button>
            </nav>

            {open && (
                <div
                    data-testid="nav-mobile-menu"
                    className="lg:hidden bg-black/90 backdrop-blur-xl border-t border-white/10 px-5 py-6 flex flex-col gap-5"
                >
                    {LINKS.map((link) => (
                        <a
                            key={link.href}
                            href={link.href}
                            data-testid={`nav-mobile-link-${link.href.slice(1)}`}
                            onClick={(e) => go(e, link.href)}
                            className="text-sm uppercase tracking-[0.18em] text-white/70 hover:text-white transition-colors duration-300"
                        >
                            {link.label}
                        </a>
                    ))}
                    <a
                        href="#contatti"
                        data-testid="nav-mobile-cta-contatti"
                        onClick={(e) => go(e, "#contatti")}
                        className="text-sm uppercase tracking-[0.18em] text-gold"
                    >
                        Contattaci
                    </a>
                    <p className="text-xs text-white/40 pt-2">{CLINIC.city}</p>
                </div>
            )}
        </header>
    );
};
